import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls window to top on every route change.
// Placed inside <BrowserRouter> so it can subscribe to location changes.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
